import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown} from '@fortawesome/pro-solid-svg-icons';

export interface ICustomerChipsSelectorProps {
  customer: {id: number | string; name: string};
  expanded: boolean;
  selectedCount: number;
  selectedSet?: Set<number>;
  crops: Array<{id: number | string; name: string}>;
  isSaving: boolean;
  onToggle: (customerId: number) => void;
  onSelect: (customerId: number, cropId: number) => void;
  onDeselect: (customerId: number, cropId: number) => void;
  isQueuedForDelete: (customerId: number, cropId: number) => boolean;
}

export const CustomerChipsSelector: React.FC<ICustomerChipsSelectorProps> = ({
  customer,
  expanded,
  selectedCount,
  selectedSet,
  crops,
  isSaving,
  onToggle,
  onSelect,
  onDeselect,
  isQueuedForDelete,
}) => {
  const customerId = Number(customer.id);

  return (
    <article
      className={`primary-customers-step__card${
        expanded ? ' is-expanded' : ''
      }`}
    >
      <button
        type="button"
        className="primary-customers-step__card-toggle"
        onClick={() => onToggle(customerId)}
        aria-expanded={expanded}
      >
        <div>
          <h4>{customer.name}</h4>
          <p>
            {selectedCount > 0
              ? `${selectedCount} ${
                  selectedCount === 1 ? 'crop' : 'crops'
                } selected`
              : 'No crops selected yet'}
          </p>
        </div>
        <FontAwesomeIcon
          icon={faChevronDown}
          className={`primary-customers-step__chevron${
            expanded ? ' is-expanded' : ''
          }`}
        />
      </button>

      {expanded ? (
        <div className="primary-customers-step__card-body">
          <p className="primary-customers-step__instruction">
            Tick the crops or products this customer usually buys from you.
          </p>

          <div
            className="primary-customers-step__chips"
            role="group"
            aria-label={`Products for ${customer.name}`}
          >
            {crops.map((crop) => {
              const cropId = Number(crop.id);
              const isSelected = Boolean(selectedSet?.has(cropId));
              const queuedForDelete = isQueuedForDelete(customerId, cropId);

              return (
                <button
                  key={`${customer.id}-${crop.id}`}
                  type="button"
                  className={`primary-customers-step__chip${
                    isSelected ? ' is-selected' : ''
                  }${queuedForDelete ? ' is-queued' : ''}`}
                  onClick={() => {
                    if (isSelected) {
                      onDeselect(customerId, cropId);
                      return;
                    }
                    onSelect(customerId, cropId);
                  }}
                  disabled={isSaving}
                  aria-pressed={isSelected}
                >
                  <span className="primary-customers-step__chip-label">
                    {crop.name}
                  </span>
                  {queuedForDelete ? (
                    <span className="primary-customers-step__chip-meta">
                      Queued remove
                    </span>
                  ) : null}
                </button>
              );
            })}
          </div>
        </div>
      ) : null}
    </article>
  );
};
